import { isFuture, isPast } from 'date-fns';

function isExpired(_, { readField }) {
  const registrationEndDate = readField('registrationEndDate');
  const bookingAvailable = readField('bookingAvailable');
  const expiredEvent =
    isPast(new Date(registrationEndDate)) || !bookingAvailable;
  return expiredEvent;
}

function isComingSoon(_, { readField }) {
  const registrationStartDate = readField('registrationStartDate');
  const expiredEvent = readField('expiredEvent');
  const comingSoonEvent =
    !expiredEvent && isFuture(new Date(registrationStartDate));
  return comingSoonEvent;
}

export const liveEventPolicy = {
  typePolicies: {
    LiveEvent: {
      fields: {
        isExpired,
        isComingSoon,
        instructors(_, { readField }) {
          const instructors = [];
          const primaryInstructor = readField('primaryInstructor');
          const otherInstructors = readField('otherInstructors');

          if (primaryInstructor) {
            instructors.push(primaryInstructor);
          }

          if (otherInstructors) {
            instructors.push(...otherInstructors);
          }

          return instructors;
        },
      },
    },
  },
};

export const searchliveEventPolicy = {
  typePolicies: {
    SearchLiveEvent: {
      fields: {
        price() {
          return null;
        },
        isExpired,
        isComingSoon,
      },
    },
  },
};
